import * as React from "react";
import * as Scrivito from "scrivito";
import { MediaComponent } from "components";
import MoreTextLinkComponent from "./MoreTextLinkComponent";

const MediaLeftComponent = Scrivito.connect(({ widget }) => {
  const cssForMediaSize =
    widget.get("mediaSize") === "small" ? "col-md-5" : "col-md-7";
  const cssForTextSize =
    widget.get("mediaSize") === "large" ? "col-md-5" : "col-md-7";

  return (
    <React.Fragment>
      <div className={cssForMediaSize} data-testid="media-left">
        <MediaComponent widget={widget} />
      </div>
      <div className={cssForTextSize}>
        <Scrivito.ContentTag tag="h5" content={widget} attribute="subtitle" />
        <Scrivito.ContentTag tag="div" content={widget} attribute="body" />
        <MoreTextLinkComponent widget={widget} />
      </div>
    </React.Fragment>
  );
});

export default MediaLeftComponent;
